import $ from 'jquery';
import _ from 'underscore';
import ajax from 'util/ajax';
import { $window } from 'util/global';
import { isInViewport, isVisibleInContainer } from 'util/ui';

/** regex to catch userAgents that must load deferred components onLoad or onDomReady */
const UA_NEEDS_AUTOSHOW_REGEX = /opera mini|series40/i;
const deferredComponents = [];
let numPendingComponents = 0;
let isListening = false;

/**
 * @param {JQuery} $component
 * @param {object} extraGETParams
 */
function load($component, extraGETParams = {}) {
  const data = $component.data();

  $component.find('.js').addClass('spinner');
  ajax(data.cmp_page_key).get(
    data.cmp_url,
    Object.assign(
      {
        param_key: data.cmp_param_key,
        deferred: true,
      },
      extraGETParams,
    ),
  );
}

/** Checks for non-loaded components and loads them as they come into view. */
function listen() {
  isListening = true;
  $window.on(
    'scroll.deferred',
    _.throttle(() => {
      const len = deferredComponents.length;
      let $cmp = false;
      for (let i = 0; i < len; i++) {
        $cmp = deferredComponents[i];
        if ($cmp !== false && isInViewport($cmp)) {
          load($cmp);
          deferredComponents[i] = false;
          numPendingComponents--;
          if (numPendingComponents === 0) {
            isListening = false;
            $window.off('scroll.deferred');
          }
        }
      }
    }, 16),
  );
}

/** Loads the component when it is shown. */
const overrideShowFunction = _.once(() => {
  const oldShow = $.fn.show;
  $.fn.show = function show(speed, callback) {
    return $(this).each((i, elem) => {
      const $elem = $(elem);
      oldShow.apply($elem, [speed, callback]);

      $elem.find('.cmp-deferred').each((j, cmp) => {
        const $cmp = $(cmp);
        if ($cmp.is(':visible')) {
          load($cmp);
        }
      });
    });
  };
});

/**
 * Determines how to load the component.
 * @param {JQuery} $cmp
 */
function add($cmp) {
  if (UA_NEEDS_AUTOSHOW_REGEX.test(navigator.userAgent)) {
    load($cmp);
    return;
  }
  if ($cmp.is(':visible')) {
    // if it's showing on the page somewhere
    if (isInViewport($cmp)) {
      // if it's in the frame, load it
      load($cmp);
    } else {
      // else, it's visible but somewhere out of view, check on it when scrolling
      deferredComponents.push($cmp);
      numPendingComponents++;
      if (!isListening) {
        listen();
      }
    }
  } else {
    // else, it's really hidden, hijack the show function
    overrideShowFunction();
  }
}

/**
 * @param {JQuery} $container
 * @param {number} numComponents
 */
function addCmpsInContainer($container, numComponents) {
  const len = deferredComponents.length;
  let i = len - numPendingComponents; // start at wherever we left off
  let componentsLeft = numComponents;
  let $cmp = false;

  for (i; i < len; i++) {
    $cmp = deferredComponents[i];
    if ($cmp !== false) {
      // Components should be in order. Don't reset `i`, pick up where you left off
      // the last time you called this function.

      if (isVisibleInContainer($cmp, $container)) {
        load($cmp);
        deferredComponents[i] = false;
        numPendingComponents--;
        componentsLeft--;
        if (componentsLeft === 0) {
          $container.off('scroll.deferred');
        }
      }
    }
  }
}

export { load, add, addCmpsInContainer };
